export const ValidateName = {

  //Function Name Constant
  REQUIRED: "required",
  ISREQUIRED_NO: "isRequiredNo",
  NOT_VALID: "notValid",
  MIN_LENGTH: "minLength",
  FAX_NUMBER: "Fax number",
  ISVALID_FAX: "isValidFax",
  ISVALID_PHONE: "isValidPhone",
  ISVALID_DATE: "isValidDate",
  DUPLICATE_EMAIL: "duplicate email",
  ISVALID_EMAIL: "isValidEmail",
  ISVALID_URL: "isValidUrl",
  END_DATE: "End date",
  EMAIL: "Email",
  CURRENCY: "Currency",
  POSITION: "Position",
  COMPANY: "company",
  SHOULD_MAX_LETTER: "maxLength",
  VALID_FILE_SIZE: "isValidFileSize",
  SHOULD_STRING: "shouldString",
  UNIQUE_ITEMS: "unique",
  ISTEXTONLY: "isTextOnly",
  ISVALID_CONVERSION_RATE: "isValidConversionRate",
  ISNUMBERONLY: "isNumberOnly",
  REQUIREDID: "requiredId",
  VALID_DATE: "validDate",
  ISPOSITIVENUMBER:"isPositiveNumber",
  USERPASSWORD:"isValidPassword",

  //Customer
  CUSTOMER_NAME: "Customer name",
  CUSTOMER_COUNTRY: "Customer country",
  CUSTOMER_ADDRESS: "Customer address",
  ASSIGNED_ENGINEER: "Assigned engineer",
  CUSTOMER_TYPE: "Customer type",
  DISTRIBUTOR: "Distributor",

  //Project
  PROJECT_NAME: "Project name",
  PROJECT_CODE: "Project code",
  PROJECT_SEGMENT: "Project segment",
  MAIN_CONTRACTOR: "Main contractor",
  PROJECT_STATUS: "Project status",
  MEP_CONTRACTOR: "Mep contractor",
  DESIGN_CONSULTANT: "Design consultant",
  SUPERVISION_CONSULTANT: "Supervision consultant",
  CUSTOMER_TYPE: "Customer type",
  DISTRIBUTOR: "Distributor",
  DISTRIBUTOR_NAME: "Distributor name",
  DISTRIBUTOR_TYPE: "Distributor type",
  DISTRIBUTOR_ADDRESS: "Distributor address",
  CONVERSION_RATE: "Conversion rate",
  COMPANY_NAME: "Company name",
  AUTHORIZED_PERSON: "Authorized person",
  CLIENT: "Client",

  //Company
  COMPANY_CODE: "Company code",
  COMPANY_NAME: "Company name",
  LOGO: "Logo",
  FOOTER: "Footer",
  HEADER: "Header",

  //Contact
  CONTACT_NAME: "Contact name",
  PROJECT_CODE: "Project code",
  PROJECT_SEGMENT: "Project segment",
  DEPARTMENT: "Department",
  DESINATION: "Designation",
  CONTACT_PERSON: "Contact person",

  //DeliveryTerms
  ABBREVIATION: "Abbreviation",
  DELIVERY_TERMS: "Delivery terms",
  DELIVERY_DESCRIPTION: "Delivery description",

  //PaymentTerms
  PAYMENT_TERMS: "Payment Terms",
  PAYMENT: "Payment",
  CREDIT_DAYS: "Credit Days",
  DESCRIPTION: "Description",

  //Enquiry
  ALLOCATEDTO: "AllocatedTo",
  ENQUIRY_REF: "Enquiry ref",
  ENQUIRY_TYPE: "Enquiry type",

    //Quotation
    QUOTE_VALIDITY:"quoteValidity",
    DELIVERY_LEADTIME:"delivery lead time",
    MODE_OF_TRANSFORT:"mode of transport",
    SALES_ENGINEER:"Sales Engineer",

    //Update Status
    QUOTE_STATUS:"quote staus",
    QUOTE_LOSTREASON:"Lost reason",
    QUOTE_LOSTTO:"Lost to",
    QUOTE_LOSTDETAILS:"Lost details",
    QUOTE_LOSTPRICE:"Lost price",

    //Forecast
    EXPECTED_AMOUNT:"Amount",
    EXPECTED_QUANTITY:"Quantity",

    WEBSITE: "Website",
    COUNTRY: "Country",
    START_DATE: "Start date",
    END_DATE: "End date",
    PHONE_NUMBER:  "Phone number",
    ADDRESS: "Address",
    AUTHORIZED_PERSON: "Authorized person",
    POSITION: "Position",
    PROJECT:"Project",

    //Order
    QUOTE_REF:"Quotation reference",
    PO_NUMBER:"Purchase order reference",
    PO_DATE:"Purchase order date",
    ORDER_TYPE:"Order type",
    BILLING_CUSTOMER:"Billing customer",
    BILLING_ADDRESS:"Billing address",
    DELIVERY_CONTACT:"Delivery contact number",

    //Approval master
    LEVEL: 'Level',
    USERNAME: 'userName',
  }
